// extracted by mini-css-extract-plugin
export default {"houseSize":"50","gameTypeOption":"RenderTypes_gameTypeOption__428Mv","gameTypeRadio":"RenderTypes_gameTypeRadio__SQJNX"};